import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { formatBalance } from 'utils';
import cn from 'classnames';

import { getPoolListData, getPoolStatisticData, getPoolUsers } from 'store/pool/actionCreators';
import { poolSelectors } from 'store/pool/selectors';

import { WhiteContainer } from 'containers';
import {
  SelectTabs,
  TitleText,
} from 'components';

import { TabContentTopSeller } from './tabContentTopSeller';

import styles from './styles.module.scss';

const pool = [
  {
    title: ['advanced_seller', 'premium_seller', 'top_seller'],
    id: 3,
    name: 'advanced_seller',
    sales: 5000,
  },
  {
    title: ['top_seller'],
    id: 5,
    name: 'top_seller',
    sales: 10000,
  },
];

export const PoolSellersContainer = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('status');
  const trans = useTranslation('main').t;
  const list = useSelector(poolSelectors.getProp('poolList'));
  const statistic = useSelector(poolSelectors.getProp('poolStatistic'));

  const [tab, setTab] = useState(0);

  useEffect(() => {
    dispatch(getPoolListData());
  }, [dispatch]);

  useEffect(() => {
    if (list[tab]?.id) {
      dispatch(getPoolStatisticData({ rankName: list[tab]?.name }));
      dispatch(getPoolUsers({ rankName: list[tab]?.name }));
    }
  }, [
    dispatch,
    list,
    tab,
  ]);

  const onSelectTab = useCallback((n: number) => {
    setTab(n);
  }, [setTab]);

  return (
    <div className={styles.status_container}>
      <div className={styles.status_top}>
        <TitleText
          text={t('Pools_')}
          className={styles.status_top_title}
        />
        <div className={styles.status_top_info}>
          <SelectTabs
            tabTitles={[[`${trans('advanced_seller')} & ${trans('premium_seller')} & ${trans('top_seller')}`], [`${trans('top_seller')}`]]}
            onSelect={onSelectTab}
            classNameTabContent={styles.status_top_info_tab}
          />
        </div>
      </div>
      <div className={styles.seller_top_container}>
        <WhiteContainer>
          <TabContentTopSeller data={pool[tab]} />
        </WhiteContainer>
        <div className={styles.seller_right}>
          <div className={styles.seller_right_content}>
            <div className={styles.seller_right_subtitle}>
              {t('Balance_within_pool_')}
            </div>
            <div
              className={cn(styles.seller_right_title, {
                [styles.seller_right_title_small]:
                  formatBalance(statistic?.pool_balance).toString().length > 7,
              })}
            >
              {formatBalance(statistic?.pool_balance)}
              {' '}
              $
            </div>
          </div>
          <div className={styles.seller_line} />
          <div>
            <div
              className={cn(styles.seller_right_title, {
                [styles.seller_right_title_small]:
                    formatBalance(statistic?.reward).toString().length > 7,
              })}
            >
              {formatBalance(statistic?.reward)}
              {' '}
              $
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
